import { InitialValues, QuestionnaireAnswerDeafultValue } from 'constants/questionnaires';
import { QuestionnaireAnswerResponse, QuestionnairesAnswerResponse } from 'pages/Questionnaire/types';
import { Questionnaire } from 'types/questionnaire';

const getQuestionnaireAnswers = (questions: QuestionnaireAnswerResponse) => {
    return questions.answers.reduce((answers, { shortQuestionName, answer }: Questionnaire) => {
        return {
            ...answers,
            [shortQuestionName]: answer || QuestionnaireAnswerDeafultValue
        };
    }, {});
};

export const getQuestionnaireObject = (questionnaires: QuestionnairesAnswerResponse) => {
    return questionnaires.data?.reduce((questionnaireObject, questionnaire) => {
        return { ...questionnaireObject, ...getQuestionnaireAnswers(questionnaire) };
    }, InitialValues);
};
